import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useNeedsToShowBotPaywall } from '~features/paywall';
import { Toaster } from '~features/toaster';
import { useModal } from '~hooks/useModal';
import { useUserId } from '~hooks/useUserId';
import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';
import { userApi } from '~services/api/user';
import { logout } from '~store/utils/logout';

import type { AppDispatch } from '../../store';

export const useDeleteAccount = () => {
	const dispatch = useDispatch<AppDispatch>();
	const userId = useUserId();
	const { open, isOpen: confirmOpened, close: cancel } = useModal();
	const [deleteUser] = userApi.useUserDeleteMutation();
	const confirm = open();
	const { setNeedsToShowBotPaywall } = useNeedsToShowBotPaywall();

	const act = useCallback(async () => {
		try {
			setNeedsToShowBotPaywall(undefined);
			await deleteUser({ userId }).unwrap();
			localStorage.clear();
			Toaster.showSuccess({ titleKey: 'userDeletedSuccess' });
			dispatch(logout());
		} catch (e) {
			ClientLogger.error(
				LoggerServices.UserService,
				LoggerMessages.UserDeleteError,
				{ error: e }
			);
			Toaster.showError({ titleKey: 'userDeletionFailed' });
		}
		//eslint-disable-next-line
	}, [deleteUser, dispatch, userId]);

	return { confirm, cancel, confirmOpened, act };
};
